/* SC species popup step (r55, 30 Oct 2026)
   Step 1 of the sign-up popup: "Who are we feeding?" using the site's species combobox (sc-breed-combobox.js).
   Next opens the Klaviyo form by custom trigger. The species is written to the profile on the email step.
   A custom trigger switches off Klaviyo's own visitor rules, so this file applies them:
   unidentified only, never after a submit, 14 days after a close, 10s delay or exit intent or 3 pages, URL deny list.
   r54 teaser: closing the species step (X, decline, Esc) leaves a "Get $5 off" tab on the left edge, on this and later
   pages, so the species arm keeps the same way back in that Klaviyo's own teaser gives the control. Tapping it reopens
   the species step. It is cleared once the Klaviyo form opens (Klaviyo's teaser takes over), on submit, when the visitor
   is identified, or when its X is tapped. Species variant only.
   r55: until an email is given, every way back in goes through the species step.
   - Same page, after the Klaviyo form was closed: Klaviyo's own teaser is the one tab (same size as ours). A tap on it
     is intercepted and opens the species step; Next then reopens Klaviyo by clicking its teaser for it, which is
     Klaviyo's own reopen path. (openForm on a form already closed this page reopens it without an 'open' event and
     can leave Klaviyo stuck, and hiding its teaser with display:none freezes its close animation as an invisible
     full-page layer. Both were seen live on 30 Oct 2026, so neither is used.)
   - Later pages: Klaviyo's teaser does not carry over, so our tab stays armed until an email is given.
   - Once an email is given, Klaviyo's teaser is left alone (SMS step and code) and our tab retires.
   Test: ?sc_sp_test=1 (shows at once, ignores the rules) &sc_sp_form=FORMID &sc_sp_variant=species|control. Reset: ?sc_sp_reset=1 */
(function () {
  'use strict';
  if (window.__SC_SP_INIT__) return;
  window.__SC_SP_INIT__ = true;

  var cfgEl = document.getElementById('sc-sp-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var Q = new URLSearchParams(location.search);
  var TEST = Q.get('sc_sp_test') === '1';
  var K = { last: 'sc_sp_last', variant: 'sc_sp_variant', pending: 'sc_sp_pending', done: 'sc_sp_submitted', pv: 'sc_sp_pv', teaser: 'sc_sp_teaser', email: 'sc_sp_email' };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function readJSON(k) { try { return JSON.parse(lsGet(k) || 'null'); } catch (e) { return null; } }

  if (Q.get('sc_sp_reset') === '1') {
    [K.last, K.variant, K.pending, K.done, K.teaser, K.email].forEach(lsDel);
    try { sessionStorage.removeItem(K.pv); } catch (e) {}
  }

  /* Page views this session (Klaviyo "3 pages" rule). Counted before any early return. */
  var pv = 0;
  try { pv = Number(sessionStorage.getItem(K.pv) || 0) + 1; sessionStorage.setItem(K.pv, String(pv)); } catch (e) {}

  /* species_group: one clean key per species family, used for flow splits. Specific before family. */
  var GROUPS = [
    [/dove|pigeon/, 'dove-pigeon'],
    [/galah/, 'galah'],
    [/corella/, 'corella'],
    [/cockatiel/, 'cockatiel'],
    [/cockatoo|gang-gang/, 'cockatoo'],
    [/budgerigar|budgie/, 'budgie'],
    [/lovebird/, 'lovebird'],
    [/lorikeet|\blor(y|ies)\b/, 'lorikeet'],
    [/eclectus/, 'eclectus'],
    [/african grey|timneh/, 'african-grey'],
    [/alexandrine/, 'alexandrine'],
    [/ringneck|rose-ringed/, 'indian-ringneck'],
    [/macaw/, 'macaw'],
    [/conure/, 'conure'],
    [/quaker/, 'quaker'],
    [/amazon/, 'amazon'],
    [/caique/, 'caique'],
    [/king parrot/, 'king-parrot'],
    [/princess parrot/, 'princess-parrot'],
    [/rosella/, 'rosella'],
    [/parrotlet/, 'parrotlet'],
    [/kakariki/, 'kakariki'],
    [/bourke/, 'bourkes-parrot'],
    [/senegal/, 'senegal'],
    [/pionus/, 'pionus'],
    [/^canary($| |\()/, 'canary'],
    [/finch|waxbill|munia|silverbill|firetail|avadavat|whydah|java sparrow|cordon-bleu|green singer/, 'finch'],
    [/parrot|parakeet/, 'other-parrot']
  ];
  function speciesGroup(s) {
    s = String(s || '').toLowerCase().trim();
    if (!s) return '';
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i][0].test(s)) return GROUPS[i][1];
    return 'other';
  }
  window.SC_speciesGroup = speciesGroup;

  /* Identity */
  function klaCookie() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return null;
    try { return JSON.parse(atob(decodeURIComponent(m[1]))); } catch (e) { return null; }
  }
  function klaIdentified() {
    var k = klaCookie();
    return !!(k && (k.$exchange_id || k.$email || k.$phone_number));
  }
  function isIdentified() {
    return !!(C.customer || lsGet('sc_kl_email') || klaIdentified());
  }
  function pushIdentify(p) {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try { window.klaviyo.identify(p); return; } catch (e) {}
    }
    var lp = {};
    for (var k in p) lp[k === 'email' ? '$email' : k] = p[k];
    (window._learnq = window._learnq || []).push(['identify', lp]);
  }

  /* A species picked on an earlier visit, with the form closed before the email step:
     write it once the browser is known (quiz, cart, checkout or a later sign-up). */
  (function writeBackPending() {
    var p = readJSON(K.pending);
    if (!p || !(p.species_breed || p.species_other) || !klaIdentified()) return;
    var payload = {};
    for (var key in p) payload[key] = p[key];
    payload.species_source = 'popup_later';
    pushIdentify(payload);
    lsDel(K.pending);
  })();

  if (!C.enabled && !TEST) return;
  if (C.designMode && !TEST) return;

  /* Variant: species step vs current form (control). Sticky per browser. */
  var share = Number(C.share);
  var variant = Q.get('sc_sp_variant') || lsGet(K.variant);
  if (variant !== 'species' && variant !== 'control') {
    variant = (Math.random() * 100 < share) ? 'species' : 'control';
    lsSet(K.variant, variant);
  }
  if (!Q.get('sc_sp_variant')) {
    if (share >= 100) variant = 'species';
    if (share <= 0) variant = 'control';
  }
  var us = String(C.country || '').toUpperCase() === 'US';
  var speciesForm = Q.get('sc_sp_form') || (us ? C.formUs : C.formDefault);
  var controlForm = us ? C.controlUs : C.controlDefault;
  if (variant === 'control' && !controlForm) variant = 'species';
  var formId = variant === 'control' ? controlForm : speciesForm;
  if (!formId) return;
  var OUR_FORMS = [C.formDefault, C.formUs, C.controlDefault, C.controlUs, speciesForm].filter(Boolean);

  function track(action, extra) {
    var d = { event: 'sc_species_popup', sp_action: action, sp_variant: variant };
    if (extra) for (var k in extra) d['sp_' + k] = extra[k];
    (window.dataLayer = window.dataLayer || []).push(d);
  }
  function markLast(reason) { lsSet(K.last, JSON.stringify({ t: Date.now(), r: reason })); }

  /* Eligibility (Klaviyo's rules, applied here) */
  function recentlyClosed() {
    var l = readJSON(K.last);
    return !!(l && l.t && (Date.now() - l.t) < Number(C.days || 14) * 864e5);
  }
  function denied() {
    var href = location.href;
    return (C.deny || []).some(function (pat) {
      pat = String(pat || '').trim();
      if (!pat) return false;
      var re = new RegExp('^' + pat.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$', 'i');
      return re.test(href);
    });
  }

  /* Klaviyo form events: hand-off, species write, frequency */
  var root = null, lastFocus = null, handoffTimer = null, written = false, shown = false, armed = true, delayTimer = null, teaserEl = null;
  var klClosedHere = false, klPass = false, failedHere = false;
  var klOpen = {}; /* Klaviyo forms open on this page right now (any form, ours or not) */
  function klAnyOpen() { for (var f in klOpen) return true; return false; }

  function ownsReentry() { return !!C.teaser && variant === 'species'; }
  function emailGiven() { return written || !!lsGet(K.email) || !!lsGet(K.done); }

  var SPECIES_FORMS = [C.formDefault, C.formUs, speciesForm].filter(Boolean);
  function klTeaserOf(el) {
    var t = el && el.closest ? el.closest('[class*="kl-teaser-"]') : null;
    if (!t) return null;
    var m = String(t.className).match(/kl-teaser-(\w+)/);
    return m && SPECIES_FORMS.indexOf(m[1]) !== -1 ? t : null;
  }
  function klTeaserBtn() { return document.querySelector('.kl-teaser-' + formId + ' [role="button"]'); }
  function klTeaserSel(suffix) {
    return SPECIES_FORMS.map(function (f) { return 'html body .kl-teaser-' + f + (suffix || ''); }).join(',');
  }
  /* r57b: Klaviyo's own teaser for our forms gets the same slim tab as ours (32px wide, length fits the text, 14px).
     Klaviyo scopes form custom CSS to the form (@scope), so its teaser can only be styled from the page. */
  (function sizeKlTeaser() {
    var st = document.createElement('style');
    st.id = 'sc-sp-klteaser-size';
    st.textContent = klTeaserSel() + '{width:auto!important;min-width:96px!important}' +
      klTeaserSel(' [data-testid="animated-teaser"]>span[role="button"]') + '{min-height:32px!important;padding:0 15px!important;border-radius:0 0 12px 12px!important}' +
      klTeaserSel(' [data-testid="animated-teaser"] p span') + '{font-size:14px!important;line-height:17px!important;white-space:nowrap!important}';
    document.head.appendChild(st);
  })();
  /* Klaviyo's teaser sits at z-index 90000, above our step. Hide it (visibility only, never display:none)
     while our step is open over it. Its children carry Klaviyo's reset class, which sets visibility back to visible,
     so the rule covers every element inside it too. */
  function hideKlTeaser() {
    if (document.getElementById('sc-sp-klteaser')) return;
    var st = document.createElement('style');
    st.id = 'sc-sp-klteaser';
    st.textContent = klTeaserSel() + ',' + klTeaserSel(' *') + '{visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(st);
  }
  function showKlTeaser() {
    var st = document.getElementById('sc-sp-klteaser');
    if (st && st.parentNode) st.parentNode.removeChild(st);
  }

  /* Tap on Klaviyo's teaser before an email is given: open the species step instead of the email step. */
  function onKlTeaserTap(e) {
    if (klPass || root || failedHere || !ownsReentry() || emailGiven()) return; /* after a failed hand-off, leave Klaviyo's tab alone */
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var t = klTeaserOf(e.target);
    if (!t) return;
    if (e.target.closest('button')) {
      /* Its X: let Klaviyo dismiss it, and keep our tab away on later pages too. */
      if (e.type === 'click') lsSet(K.teaser, 'x');
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    hideKlTeaser();
    track('kl_teaser_open');
    openSpecies('kl_teaser');
  }
  window.addEventListener('click', onKlTeaserTap, true);
  window.addEventListener('keydown', onKlTeaserTap, true);

  /* r57: on phones Klaviyo puts focus in the first field of each popup step, which opens the keypad before the visitor
     has read the step. On touch screens, for our forms, that automatic focus goes to the popup's close button instead
     (what Klaviyo does on desktop). Any tap or key press ends the guard, so a tap on a field opens the keypad as normal. */
  var TOUCH = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var focusGuard = { id: '', until: 0 };
  function guardedField(el) {
    if (!el || Date.now() > focusGuard.until || !/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return null;
    var f = el.closest ? el.closest('form[data-testid="klaviyo-form-' + focusGuard.id + '"]') : null;
    return f ? el : null;
  }
  function parkFocus(el) {
    var box = el.closest('[role="dialog"]') || el.form;
    var x = box ? box.querySelector('button.klaviyo-close-form') : null;
    if (x && x.getClientRects().length) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    if (document.activeElement === el) { try { el.blur(); } catch (e) {} }
  }
  function guardKlFocus(id) {
    if (!TOUCH) return;
    focusGuard = { id: id, until: Date.now() + 3000 };
    /* Backstop for browsers that skip focus events: check where focus landed. */
    [300, 800, 1600, 2800].forEach(function (ms) {
      setTimeout(function () { var a = guardedField(document.activeElement); if (a) parkFocus(a); }, ms);
    });
  }
  if (TOUCH) {
    var endGuard = function () { focusGuard.until = 0; };
    document.addEventListener('pointerdown', endGuard, true);
    document.addEventListener('keydown', endGuard, true);
    document.addEventListener('focusin', function (e) { var a = guardedField(e.target); if (a) parkFocus(a); }, true);
  }

  window.addEventListener('klaviyoForms', function (e) {
    var d = (e && e.detail) || {};
    var id = d.formId;
    if (!id) return;
    /* Never show our tab while any Klaviyo form is open. 'close' (not 'submit') clears it, because a
       submitted form still shows its success step until it is closed. */
    if (d.type === 'open') { klOpen[id] = 1; hideTeaser(); }
    if (d.type === 'close') delete klOpen[id];
    if ((d.type === 'open' || d.type === 'viewedStep') && OUR_FORMS.indexOf(id) !== -1) guardKlFocus(id);
    if (OUR_FORMS.indexOf(id) === -1) {
      if (d.type === 'open' && !shown) armed = false; /* another Klaviyo popup is up: stand down this page */
      /* Another popup closed: bring our tab back if it was waiting (later pages, before our form opened here). */
      if (d.type === 'close' && !klClosedHere && teaserArmed() && !root) showTeaser();
      return;
    }
    if (d.type === 'open') { if (root && id === formId) onKlaviyoOpen(); return; }
    if (d.type === 'stepSubmit' || d.type === 'submit') {
      var md = d.metaData || {};
      var email = md.$email || md.email || '';
      if (email) {
        /* On the list now: Klaviyo's teaser takes over (SMS step, code) and our tab retires. */
        lsSet(K.email, '1');
        lsDel(K.teaser);
        hideTeaser();
        showKlTeaser();
      }
      if (email && !written) {
        written = true;
        var p = readJSON(K.pending) || {};
        var payload = { email: email, sc_popup_variant: variant };
        for (var k in p) payload[k] = p[k];
        if (p.species_breed || p.species_other) {
          payload.species_source = 'popup';
          payload.species_captured_at = new Date().toISOString();
        }
        pushIdentify(payload);
        lsDel(K.pending);
        track('email', { form: id });
      }
      if (d.type === 'submit') { lsSet(K.done, '1'); lsDel(K.teaser); hideTeaser(); showKlTeaser(); markLast('submit'); track('submit', { form: id }); }
      return;
    }
    if (d.type === 'close') {
      markLast('close');
      /* Klaviyo's teaser is the tab on this page from now on (tap is routed to the species step above). */
      klClosedHere = true;
      hideTeaser();
    }
  });

  if (!TEST) {
    if (lsGet(K.done) || lsGet(K.email) || isIdentified()) { lsDel(K.teaser); return; }
    if (denied()) return;
    if (recentlyClosed()) { if (teaserArmed()) afterLoad(showTeaser); return; }
  }

  function openKlaviyo(id) {
    window._klOnsite = window._klOnsite || [];
    try { window._klOnsite.push(['openForm', id]); } catch (e) {}
  }

  var cssReady = null;
  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (res) {
      if (!C.cssUrl) return res();
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = C.cssUrl;
      l.onload = res;
      l.onerror = res;
      document.head.appendChild(l);
      setTimeout(res, 3000);
    });
    return cssReady;
  }
  function loadFonts() {
    if (!C.fontsUrl || document.getElementById('sc-sp-fonts')) return;
    var l = document.createElement('link');
    l.id = 'sc-sp-fonts';
    l.rel = 'stylesheet';
    l.href = C.fontsUrl;
    document.head.appendChild(l);
  }

  /* ---------- Species step ---------- */
  function q(sel) { return root ? root.querySelector(sel) : null; }
  function val(id) {
    var h = q('#' + id + ' [data-sc-breed-value]');
    return h ? String(h.value || '').toLowerCase().trim() : '';
  }
  function typed(id) {
    var i = q('#' + id + ' [data-sc-breed-input]');
    return i ? String(i.value || '').trim() : '';
  }
  function showError(msg) {
    var el = q('[data-sc-sp-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function openSpecies(reason) {
    var tpl = document.getElementById('sc-sp-template');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    loadFonts();
    loadCss().then(function () {
      root = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(root);
      document.documentElement.classList.add('sc-sp-lock');
      if (window.SC_initBreedComboboxes) window.SC_initBreedComboboxes(root);
      bind();
      lastFocus = document.activeElement;
      var panel = q('.sc-sp__panel');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        if (panel) panel.focus({ preventScroll: true });
      });
      track('view', { reason: reason, form: formId });
    });
  }

  function bind() {
    root.querySelectorAll('[data-sc-sp-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeSpecies(b.hasAttribute('data-sc-sp-decline') ? 'decline' : 'close'); });
    });
    var more = q('[data-sc-sp-more]');
    var bird2 = q('[data-sc-sp-bird2]');
    if (more && bird2) {
      more.addEventListener('change', function () {
        bird2.hidden = !more.checked;
        if (!more.checked) {
          var h = q('#scSpBird2 [data-sc-breed-value]');
          var i = q('#scSpBird2 [data-sc-breed-input]');
          if (h) { h.value = ''; h.dispatchEvent(new Event('change', { bubbles: true })); }
          if (i) { i.value = ''; i.classList.add('is-placeholder'); }
        }
      });
    }
    var next = q('[data-sc-sp-next]');
    if (next) next.addEventListener('click', function () { onNext(false); });
    var skip = q('[data-sc-sp-skip]');
    if (skip) skip.addEventListener('click', function () { onNext(true); });
    root.addEventListener('keydown', onKey);
    root.addEventListener('change', function () { showError(''); }, true);
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      if (e.defaultPrevented) return; /* the combobox used Escape to close its list */
      e.preventDefault();
      closeSpecies('esc');
      return;
    }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      root.querySelectorAll('button, input:not([type="hidden"]), [tabindex="0"]'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function onNext(skip) {
    var b1 = val('scSpBird1');
    var more = q('[data-sc-sp-more]');
    var b2 = more && more.checked ? val('scSpBird2') : '';
    if (!skip && !b1) { showError(C.errorText || 'Pick your bird from the list, or skip this step.'); return; }
    var sp = {};
    if (b1) { sp.species_breed = b1; sp.species_group = speciesGroup(b1); }
    if (b2 && b2 !== b1) { sp.species_breed2 = b2; sp.species_group2 = speciesGroup(b2); }
    if (!b1) { var t = typed('scSpBird1'); if (t) sp.species_other = t.slice(0, 60); }
    /* Back in through the tab and skipped this time: keep the bird picked earlier rather than wiping it. */
    if (!b1 && !sp.species_other) {
      var prev = readJSON(K.pending);
      if (prev && (prev.species_breed || prev.species_other)) sp = prev;
    }
    lsSet(K.pending, JSON.stringify(sp));
    /* Same keys the Bird Finder uses, so the cart drawer prefills the bird. */
    if (b1) lsSet('species_breed', b1);
    if (sp.species_breed2) lsSet('species_breed2', sp.species_breed2);
    track(b1 ? 'select' : 'skip', { species: b1, species2: sp.species_breed2 || '' });
    handoff();
  }

  function handoff() {
    var btn = q('[data-sc-sp-next]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    root.classList.add('is-handoff');
    var kt = klTeaserBtn();
    var waitMs = kt ? 8000 : 4000; /* a teaser reopen took up to 2.8s live, right after a close */
    if (kt) {
      /* Form already closed on this page: reopen through Klaviyo's own teaser (fires 'open', state stays clean). */
      showKlTeaser();
      klPass = true;
      try { kt.click(); } catch (e) {}
      klPass = false;
    } else if (klClosedHere) {
      /* Closed here and its teaser dismissed: openForm would reopen it in a broken state, so stop cleanly. */
      track('handoff_skip', { form: formId });
      teardown(true);
      return;
    } else {
      openKlaviyo(formId);
    }
    handoffTimer = setTimeout(function () {
      /* Klaviyo did not open (blocked or failed). Keep the species for later, do not nag, and drop the tab
         so it cannot loop the visitor back into a hand-off that keeps failing. */
      track('handoff_fail', { form: formId });
      failedHere = true;
      markLast('fail');
      lsDel(K.teaser);
      teardown(true);
    }, waitMs);
  }

  function onKlaviyoOpen() {
    if (!root || root.classList.contains('is-leaving')) return;
    clearTimeout(handoffTimer);
    track('handoff', { form: formId });
    markLast('shown'); /* the 14-day clock starts when the Klaviyo form shows */
    /* Keep our tab armed until an email is given, for later pages (Klaviyo's teaser covers this page). */
    if (ownsReentry() && !emailGiven() && lsGet(K.teaser) !== 'x') lsSet(K.teaser, '1');
    hideTeaser();
    root.classList.add('is-leaving');
    setTimeout(function () { teardown(false); }, 220);
  }

  function closeSpecies(reason) {
    markLast(reason);
    track('close', { reason: reason });
    teardown(true);
    showKlTeaser();
    if (C.teaser && variant === 'species' && lsGet(K.teaser) !== 'x') {
      lsSet(K.teaser, '1');
      /* Once Klaviyo has opened and closed here, its teaser is the tab on this page. */
      if (!klClosedHere) showTeaser();
    }
  }

  /* ---------- Teaser tab ---------- */
  function teaserArmed() {
    return !!C.teaser && variant === 'species' && lsGet(K.teaser) === '1';
  }
  function afterLoad(cb) {
    if (document.readyState === 'complete') idle(cb);
    else window.addEventListener('load', function () { idle(cb); });
  }
  function showTeaser() {
    if (teaserEl || root || klAnyOpen()) return;
    var tpl = document.getElementById('sc-sp-teaser-template');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    loadCss().then(function () {
      if (teaserEl || root || klAnyOpen() || lsGet(K.teaser) !== '1') return;
      teaserEl = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(teaserEl);
      var open = teaserEl.querySelector('[data-sc-sp-teaser-open]');
      var close = teaserEl.querySelector('[data-sc-sp-teaser-close]');
      if (open) open.addEventListener('click', function () { hideTeaser(); track('teaser_open'); openSpecies('teaser'); });
      if (close) close.addEventListener('click', function () { lsSet(K.teaser, 'x'); hideTeaser(); track('teaser_close'); });
      requestAnimationFrame(function () { if (teaserEl) teaserEl.classList.add('is-in'); });
      track('teaser_view');
    });
  }
  function hideTeaser() {
    if (teaserEl && teaserEl.parentNode) teaserEl.parentNode.removeChild(teaserEl);
    teaserEl = null;
  }

  function teardown(restoreFocus) {
    clearTimeout(handoffTimer);
    if (root && root.parentNode) root.parentNode.removeChild(root);
    root = null;
    document.documentElement.classList.remove('sc-sp-lock');
    if (restoreFocus && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Triggers ---------- */
  function canShowNow() {
    if (document.querySelector('.drawer--is-open, .modal--is-active, [data-sc-sp].is-open')) return false;
    var cls = document.documentElement.className + ' ' + (document.body ? document.body.className : '');
    return !/js-drawer-open|js-modal-open/.test(cls);
  }
  function fire(reason) {
    if (shown || !armed) return;
    if (!TEST && !canShowNow()) { setTimeout(function () { fire(reason); }, 2000); return; }
    shown = true;
    detach();
    if (variant === 'control') { openKlaviyo(formId); markLast('shown'); track('view', { reason: reason, form: formId }); return; }
    openSpecies(reason);
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) fire('exit'); }
  function detach() {
    clearTimeout(delayTimer);
    document.removeEventListener('mouseout', onExit);
  }
  function idle(cb) { if ('requestIdleCallback' in window) requestIdleCallback(cb, { timeout: 4000 }); else setTimeout(cb, 2000); }

  function start() {
    if (TEST) { setTimeout(function () { fire('test'); }, 600); return; }
    if (variant === 'species') idle(loadCss);
    if (Number(C.pages) && pv >= Number(C.pages)) setTimeout(function () { fire('pages'); }, 1500);
    if (Number(C.delay)) delayTimer = setTimeout(function () { fire('delay'); }, Number(C.delay) * 1000);
    if (C.exit && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', onExit);
    }
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
